import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomvalidationService } from '../../customvalidation.service';

@Component({
  selector: 'lib-nested-filedby-section',
  templateUrl: './nested-filedby-section.component.html',
  styleUrls: ['./nested-filedby-section.component.css']
})
export class NestedFiledbySectionComponent implements OnInit {

//  @Input() headerDeclareStmt = "";
  @Input() footerDeclareStmt = "";
  @Input() SDP = false;
  @Input() filedByForm: any;
  @Input() extMaxlength = 20 ;
  @Input() firstNameMaxLen = 50 ;
  @Input() lastNameMaxLen = 50 ;
  @Input() titleMaxLen = 50 ;
  headerDeclareStmt = "I DECLARE, UNDER PENALTY OF PERJURY UNDER THE LAWS OF THE STATE OF CALIFORNIA THAT TO THE BEST OF MY KNOWLEDGE THE FOREGOING IS TRUE AND CORRECT." ;
  @Input() filedbyObj = {
	filedby_last_name : "",
	filedby_first_name : "",
	filedby_title : "",
	filedby_phAreaCd : "",
	filedby_phExchNbr : "",
	filedby_phTrnkNbr : "",
	filedby_phExtNbr : "",
	filedby_email_addr : ""
} ;


  constructor(private fb: FormBuilder, private customValidator: CustomvalidationService) { }
  errorMessages = {
    lastNameReq: "Last name required.",
    firstNameReq: "First name required.",
    phoneNbrReq: "Phone number required.",
    phoneNbrError: "Phone number is invalid. Phone number must be complete and contain only numbers. Format '(999) 999-9999'.",
    emailReq: "Email address required.",
    invalidAtDot: "Email address seems incorrect (check @ and .'s)",
    invalidEmailChar: "The username in the e-mail address contains invalid characters.",
    invalidEmailDomain: "The domain name in the e-mail address contains invalid characters.",
    invalidEmailUserName: "The username in the e-mail address doesn't seem to be valid.",
    invalidEmailIp: "Destination IP address in the e-mail address is invalid!",
    invalidDomainName: "The domain name in the e-mail address does not seem to be valid.",
    invalidDomainOrCountry: "The e-mail address must end in a well-known domain or two letter " + "country.",
    missingEmailHost: "This email address is missing a hostname!"
  }
  ngOnInit(): void {
    this.filedByForm.addControl("filedby_last_name", this.fb.control(this.filedbyObj.filedby_last_name, this.customValidator.requiredValidator()))
    this.filedByForm.addControl("filedby_first_name", this.fb.control(this.filedbyObj.filedby_first_name, this.customValidator.requiredValidator()))
    this.filedByForm.addControl("filedby_title", this.fb.control(this.filedbyObj.filedby_title))
    this.filedByForm.addControl("filedby_phAreaCd", this.fb.control(this.filedbyObj.filedby_phAreaCd, [this.customValidator.requiredValidator(), Validators.pattern('[2-9][0-9]{2}')]))
    this.filedByForm.addControl("filedby_phExchNbr", this.fb.control(this.filedbyObj.filedby_phExchNbr, [this.customValidator.requiredValidator(), Validators.pattern('[2-9][0-9]{2}')]))
    this.filedByForm.addControl("filedby_phTrnkNbr", this.fb.control(this.filedbyObj.filedby_phTrnkNbr, [this.customValidator.requiredValidator(), Validators.pattern('[0-9]{4}')]))
    this.filedByForm.addControl("filedby_phExtNbr", this.fb.control(this.filedbyObj.filedby_phExtNbr))
    this.filedByForm.addControl("filedby_email_addr", this.fb.control(this.filedbyObj.filedby_email_addr, [this.customValidator.requiredValidator(), this.customValidator.emailValidator()]))
    if (this.SDP) {
      this.filedByForm.addControl("tSDPPmt", this.fb.control(""))
    }
  }

  get filedby_last_name() {
    return this.filedByForm.get("filedby_last_name");
  }
  get filedby_first_name() {
    return this.filedByForm.get("filedby_first_name");
  }
  get filedby_title() {
    return this.filedByForm.get("filedby_title");
  }
  get filedby_phAreaCd() {
    return this.filedByForm.get("filedby_phAreaCd");
  }
  get filedby_phExchNbr() {
    return this.filedByForm.get("filedby_phExchNbr");
  }
  get filedby_phTrnkNbr() {
    return this.filedByForm.get("filedby_phTrnkNbr");
  }
  get filedby_email_addr() {
    return this.filedByForm.get("filedby_email_addr");
  }
  get filedby_tSDPPmt() {
    return this.filedByForm.get("filedby_tSDPPmt");
  }
  onInputEntry(event, nextInput) {
    let input = event.target;
    let length = input.value.length;
    let maxLength = input.attributes.maxlength.value;

    if (length >= maxLength) {
      nextInput.focus();
    }
  }


}
